export default function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/debounce.js
// module id = 1323
// module chunks = 0